export function useVariablesSearch() {}
